<template>
  <v-main grid-list-xl fluid>
    <v-layout v-bind="binding">
      <v-flex xs6 v-for="content of task" :key="content.id" class="mt-4">
        <v-card
          width="200px"
          class="pa-2 image-effect"
          loading
          @click="openImageView(content)"
        >
          <v-img
            v-if="content.value"
            :src="content.value"
            height="200px"
            contain
            loading
            :lazy-src="content.value"
          >
          </v-img>

          <v-card-title>
            {{ content.label }}
          </v-card-title>
        </v-card>
        <photo-view
          v-if="imageData"
          :dialog="dialog"
          :imageData="imageData"
          @close="closeImageView($event)"
        />
      </v-flex>
    </v-layout>
  </v-main>
</template>
<script>
import ListEditionToolbar from "@/components/Home/Forms/_Molecules/ListEditionToolbar";
import PhotoView from "../../../../../../FieldManagement/FieldWork/Data/TaskType/PhotoView.vue";
export default {
  name: "PhotoViewEditDialog",
  components: { ListEditionToolbar, PhotoView },

  props: {
    task: {
      type: Array,
      required: true
    },
    width: Number
  },
  data() {
    return {
      dialog: false,
      imageData: null
    };
  },

  computed: {
    binding() {
      const binding = {};
      if (this.width <= 700) {
        binding.column = true;
      }
      binding.row = true;
      binding.wrap = true;

      return binding;
    }
  },
  methods: {
    openImageView(imageData) {
      this.imageData = imageData;
      this.dialog = true;
    },
    closeImageView(closeImage) {
      this.dialog = closeImage;
      this.imageData = [];
    }
  }
};
</script>
<style scoped>
.image-effect:hover {
  cursor: pointer;
  transform: scale(1.04);
}
.image-effect:active {
  transform: scale(0.99);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Photos/PhotoViewEditDialog.vue